import { resourceIdZodSchema } from "@@/shared/acquire/resources/resource-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { requiredTranslatableZodSchema } from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const addRateCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("ADD_RATE_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    productId: productIdZodSchema,
    providerId: providerIdZodSchema,
    title: requiredTranslatableZodSchema,
    resourceId: resourceIdZodSchema.optional(),
});

type AddRateCommand = z.infer<typeof addRateCommandZodObject>;

const addRateCommandFactoryParamsZodObject = addRateCommandZodObject.omit({
    _id: true,
    _type: true,
    _createdAt: true,
});
type FactoryParams = z.infer<typeof addRateCommandFactoryParamsZodObject>;

const addRateCommandFactory = (params: FactoryParams) => {
    const addRateCommand: AddRateCommand = {
        ...params,
        _id: generateId({ prefix: "add_rate_command__" }),
        _type: "ADD_RATE_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return addRateCommand;
};

export {
    addRateCommandFactory,
    addRateCommandFactoryParamsZodObject,
    addRateCommandZodObject,
};
export type { AddRateCommand, FactoryParams as addRateCommandFactoryParams };
